module.exports = __webpack_public_path__ + "img/InTransitMonitoring.e354cb1d.png";